import type { AreaData, Time } from "lightweight-charts"
import type { TimeValueDataObject } from "../../data-object/graph"

const timeTransform = (time: string) => time.split('T')[0]

export const timeValueFromDataObject = (timeValeDO: TimeValueDataObject): AreaData<Time> => {
    const time = timeTransform(timeValeDO.time)
    const value = timeValeDO.value
    return new Object({ value, time }) as AreaData<Time>;
}
